<template>
	<leaflet-layer-group
		v-show="visible"
		ref="layer"
		class="map-areas"
		@layeradd="$emit('layeradd')"
	>
		<leaflet-geo-json
			v-for="area of areas"
			:key="area.id"
			:data="area.area"
			v-bind="$attrs"
			:polygonOptions="polygonOptions"
		/>
	</leaflet-layer-group>
</template>

<script>
export default {
	name: 'MapAreas',
	props: {
		areas: {
			type: Array,
			required: true
		},
		visible: {
			type: Boolean,
			default: true
		},
		polygonOptions: Object
	},
	methods: {
		getBounds() {
			return this.$refs.layer ? this.$refs.layer.getBounds() : null;
		}
	}
};
</script>
